import { createFileRoute } from "@tanstack/react-router";
import { useSession } from "@/features/auth/queries";
import { SettingsScreen } from "@/features/settings/SettingsScreen";
import { settingsSectionFrom } from "@/features/settings/sections";

interface SettingsSearch {
  /** A sign-in provider's error code, when connecting it from Account sent the player back. */
  error?: string;
}

export const Route = createFileRoute("/_authenticated/settings/{-$section}")({
  validateSearch: (search: Record<string, unknown>): SettingsSearch => ({
    error: typeof search.error === "string" ? search.error : undefined,
  }),
  staticData: { access: "account" },
  head: () => ({ meta: [{ title: "Settings · Pax.co" }] }),
  component: SettingsPage,
});

function SettingsPage() {
  const { section } = Route.useParams();
  const { data: session } = useSession();
  if (!session) return null;
  return <SettingsScreen session={session} section={settingsSectionFrom(section)} />;
}
